import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Skeleton,
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { WorkingTimeModelWeekdayTable } from '../../components/WorkingTimeModelWeekdayTable'
import {
    SingleLineTextInputSkeleton,
    SmallSingleLineTextInputSkeleton,
} from '@/components/SingleLineTextInputSkeleton'
import { WorkingTimeModelDayOfWeek } from '@/generated/Enumerations/WorkingTimeModelDayOfWeek_pb'

const seleniumPrefix = 'working-time-model-create-or-edit-pending-component'

export const WorkingTimeModelCreateOrEditPendingComponent: React.FC<{
    title: string
}> = ({ title }) => {
    const { t } = useTranslation()

    return (
        <Card>
            <CardHeader title={title} />

            <CardContent>
                <SingleLineTextInputSkeleton />

                <Skeleton
                    style={{ transform: 'unset' }}
                    height={102}
                    sx={{ marginTop: 2, marginBottom: 1 }}
                />

                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />
                <SingleLineTextInputSkeleton />

                <SingleLineTextInputSkeleton />

                <WorkingTimeModelWeekdayTable
                    days={[
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.MONDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.TUESDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.WEDNESDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.THURSDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.FRIDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.SATURDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                        {
                            dayOfWeek: WorkingTimeModelDayOfWeek.SUNDAY,
                            startAt: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                            duration: (
                                <SmallSingleLineTextInputSkeleton
                                    margin={false}
                                />
                            ),
                        },
                    ]}
                />
            </CardContent>

            <CardActions style={{ justifyContent: 'flex-end' }}>
                <Button
                    disabled={true}
                    data-selenium={`${seleniumPrefix}-back`}
                >
                    {t('common.back')}
                </Button>
                <Button
                    variant={'outlined'}
                    disabled={true}
                    data-selenium={`${seleniumPrefix}-save`}
                >
                    {t('common.save')}
                </Button>
            </CardActions>
        </Card>
    )
}
